export const BUSINESS_LOGGER_LIMITS = {
  /** 总维度数限制（包含 eventName） */
  TOTAL_DIMENSIONS: 10,
  /** 事件名称最大长度 */
  EVENT_NAME: 32,
  /** 维度名称最大长度 */
  CATEGORY_NAME: 32,
  /** 维度值最大长度 */
  CATEGORY_VALUE: 128,
  /** 消息最大长度 */
  MESSAGE: 1024,
  /** 模板实例缓存最大数量 */
  MAX_CACHE_SIZE: 20,
};

/**
 * 允许的业务监控键值
 * 每个键值代表一个具体的业务模块，用于数据分析和监控
 */
export const BUSINESS_LOGGER_KEYS = [
  'common', // 公共模块，比如请求统一添加的logger
  'pay_stat', // 支付统计模块
  'cart', // 购物车模块
  'dp', // 商品详情页模块
  'login', // 登录模块
  'address', // 地址模块
  'profile', // 个人中心模块
  'coupon', // 优惠券模块
  'wish_list', // 心愿单模块
  'product_card', // 商卡模块
  'message', // 消息模块
  'feedback', // 意见反馈模块
  'unsubscribe', // 邮件退订模块
  'order', // 订单
  'afterSales', // 售后
  'product_search', //搜索模块
  'invite_friend', // 邀请有礼
  'membership', // 会员模块
  'best_sellers', // 营销榜单
] as const;

/**
 * 允许的业务监控键值类型
 */
export type AllowedBusinessLoggerKey = (typeof BUSINESS_LOGGER_KEYS)[number];

/**
 * SGM 维度名称常量
 */
export const SGM_DIMENSION_NAMES = {
  /** 事件名称维度 */
  EVENT_NAME: 'eventName',
};
